module.exports = __webpack_public_path__ + "static/media/48.bccfcbdc.jpg";